(function () {
  var STEP_LABELS = { suit: 'Suit', shirt: 'Shirt', tie: 'Tie & pocket square set' };

  function init(root) {
    var bundleVariantId = root.getAttribute('data-bundle-variant-id');
    var cartAddUrl = root.getAttribute('data-cart-add-url');
    var checkoutUrl = root.getAttribute('data-checkout-url');

    var state = {
      currentStep: 1,
      suit: null,
      shirt: null,
      tie: null,
    };

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    var indicators = Array.prototype.slice.call(root.querySelectorAll('[data-step-indicator]'));

    function showStep(stepNumber) {
      state.currentStep = stepNumber;
      steps.forEach(function (step) {
        var isActive = Number(step.getAttribute('data-step')) === stepNumber;
        step.hidden = !isActive;
        step.classList.toggle('is-active', isActive);
      });
      indicators.forEach(function (indicator) {
        var num = Number(indicator.getAttribute('data-step-indicator'));
        indicator.classList.toggle('is-active', num === stepNumber);
        indicator.classList.toggle('is-complete', num < stepNumber);
      });
      if (stepNumber === 4) renderSummary();
      if (stepNumber === 2 || stepNumber === 3) renderSidebarSummary(stepNumber);
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    root.querySelectorAll('[data-step-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showStep(Number(btn.getAttribute('data-step-next')) + 1);
      });
    });
    root.querySelectorAll('[data-step-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showStep(Number(btn.getAttribute('data-step-back')) - 1);
      });
    });

    function setupPicker(kind) {
      var grid = root.querySelector('[data-picker-grid="' + kind + '"]');
      if (!grid) return;
      var pickerContainer = root.querySelector('[data-variant-picker="' + kind + '"]');
      var nextBtn = root.querySelector('[data-step-next="' + { suit: 1, shirt: 2, tie: 3 }[kind] + '"]');
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-picker-card]'));

      var emptyMessage = grid.parentElement.querySelector('[data-empty-message]');
      if (emptyMessage) emptyMessage.hidden = cards.length > 0;

      function selectCard(card) {
        cards.forEach(function (c) { c.classList.toggle('is-selected', c === card); });
        var handle = card.getAttribute('data-handle');
        var title = card.getAttribute('data-title');
        if (nextBtn) nextBtn.disabled = true;
        state[kind] = null;

        var placeholder = root.querySelector('[data-sidebar-placeholder="' + kind + '"]');
        if (placeholder) placeholder.hidden = true;

        fetch('/products/' + handle + '.js')
          .then(function (res) { return res.json(); })
          .then(function (product) {
            renderVariantPicker(kind, product, title, pickerContainer, nextBtn);
          })
          .catch(function () {
            pickerContainer.hidden = false;
            pickerContainer.innerHTML = '<p class="suit-builder__variant-message is-error">Couldn’t load this product. Please try another.</p>';
          });
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function () { selectCard(card); });
      });

      return { cards: cards, selectCard: selectCard };
    }

    function renderVariantPicker(kind, product, title, container, nextBtn) {
      container.hidden = false;
      container.innerHTML = '';

      var titleEl = document.createElement('div');
      titleEl.className = 'suit-builder__variant-picker-title';
      titleEl.textContent = title;
      container.appendChild(titleEl);

      var messageEl = document.createElement('p');
      messageEl.className = 'suit-builder__variant-message';

      var hasRealOptions = product.options && product.options.some(function (opt) {
        return !(opt.values.length === 1 && opt.values[0] === 'Default Title');
      });

      var selects = [];

      function resolveVariant() {
        var selectedValues = selects.map(function (s) { return s.value; });
        var variant = product.variants.find(function (v) {
          var optionValues = [v.option1, v.option2, v.option3].filter(function (v) { return v !== null; });
          return optionValues.every(function (val, i) { return val === selectedValues[i]; });
        });

        if (!variant) {
          messageEl.textContent = '';
          messageEl.className = 'suit-builder__variant-message';
          if (nextBtn) nextBtn.disabled = true;
          state[kind] = null;
          return;
        }

        if (!variant.available) {
          messageEl.textContent = 'That combination is currently out of stock — try a different size.';
          messageEl.className = 'suit-builder__variant-message is-error';
          if (nextBtn) nextBtn.disabled = true;
          state[kind] = null;
          return;
        }

        messageEl.textContent = 'In stock and ready to go.';
        messageEl.className = 'suit-builder__variant-message is-ok';
        if (nextBtn) nextBtn.disabled = false;
        state[kind] = {
          productTitle: title,
          variantId: variant.id,
          variantTitle: variant.title === 'Default Title' ? '' : variant.title,
        };
      }

      function refreshOptionAvailability() {
        selects.forEach(function (select, index) {
          var priorValues = selects.slice(0, index).map(function (s) { return s.value; });
          Array.prototype.forEach.call(select.options, function (opt) {
            if (!opt.value) return;
            var isAvailable = product.variants.some(function (v) {
              var optionValues = [v.option1, v.option2, v.option3];
              if (optionValues[index] !== opt.value) return false;
              return priorValues.every(function (val, i) { return !val || optionValues[i] === val; });
            });
            opt.textContent = opt.value + (isAvailable ? ' — In stock' : ' — Out of stock');
            opt.disabled = !isAvailable;
          });
        });
      }

      if (hasRealOptions) {
        product.options.forEach(function (option, index) {
          var fieldId = 'suit-builder-option-' + kind + '-' + index;

          var label = document.createElement('label');
          label.className = 'suit-builder__option-label';
          label.setAttribute('for', fieldId);
          label.textContent = option.name;
          container.appendChild(label);

          var select = document.createElement('select');
          select.id = fieldId;

          var placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = 'Select ' + option.name;
          select.appendChild(placeholder);

          option.values.forEach(function (value) {
            var opt = document.createElement('option');
            opt.value = value;
            opt.textContent = value;
            select.appendChild(opt);
          });

          select.addEventListener('change', function () {
            refreshOptionAvailability();
            resolveVariant();
          });
          selects.push(select);
          container.appendChild(select);
        });
        refreshOptionAvailability();
      } else {
        var onlyVariant = product.variants[0];
        if (onlyVariant.available) {
          messageEl.textContent = 'In stock and ready to go.';
          messageEl.className = 'suit-builder__variant-message is-ok';
          if (nextBtn) nextBtn.disabled = false;
          state[kind] = { productTitle: title, variantId: onlyVariant.id, variantTitle: '' };
        } else {
          messageEl.textContent = 'This item is currently out of stock.';
          messageEl.className = 'suit-builder__variant-message is-error';
          if (nextBtn) nextBtn.disabled = true;
          state[kind] = null;
        }
      }

      container.appendChild(messageEl);
    }

    var suitPicker = setupPicker('suit');
    setupPicker('shirt');
    setupPicker('tie');

    function selectionText(kind) {
      var entry = state[kind];
      return entry ? entry.productTitle + (entry.variantTitle ? ' — ' + entry.variantTitle : '') : 'Not selected';
    }

    function buildSummaryItem(kind) {
      var li = document.createElement('li');
      var strong = document.createElement('strong');
      strong.textContent = STEP_LABELS[kind];
      li.appendChild(strong);
      li.appendChild(document.createTextNode(selectionText(kind)));
      return li;
    }

    function renderSummary() {
      var summaryEl = root.querySelector('[data-summary]');
      if (!summaryEl) return;
      summaryEl.innerHTML = '';
      ['suit', 'shirt', 'tie'].forEach(function (kind) {
        summaryEl.appendChild(buildSummaryItem(kind));
      });
    }

    var priorKindsByStep = { 2: ['suit'], 3: ['suit', 'shirt'] };

    function renderSidebarSummary(stepNumber) {
      var kinds = priorKindsByStep[stepNumber];
      var summaryEl = root.querySelector('[data-sidebar-summary="' + stepNumber + '"]');
      if (!summaryEl || !kinds) return;
      summaryEl.innerHTML = '';
      kinds.forEach(function (kind) {
        summaryEl.appendChild(buildSummaryItem(kind));
      });
      summaryEl.hidden = false;
    }

    var checkoutBtn = root.querySelector('[data-checkout-btn]');
    var errorEl = root.querySelector('[data-builder-error]');

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        if (errorEl) errorEl.hidden = true;

        if (!bundleVariantId) {
          showError('This page isn’t fully set up yet — an admin needs to choose the £299 bundle product in the theme editor.');
          return;
        }
        if (!state.suit || !state.shirt || !state.tie) {
          showError('Please choose a suit, shirt and tie & pocket square set before checking out.');
          return;
        }

        checkoutBtn.disabled = true;
        checkoutBtn.classList.add('loading');

        fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: bundleVariantId,
                quantity: 1,
                properties: {
                  Suit: state.suit.productTitle + (state.suit.variantTitle ? ' — ' + state.suit.variantTitle : ''),
                  Shirt: state.shirt.productTitle + (state.shirt.variantTitle ? ' — ' + state.shirt.variantTitle : ''),
                  'Tie & Pocket Square Set': state.tie.productTitle,
                },
              },
            ],
          }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart-add-failed');
            return res.json();
          })
          .then(function () {
            window.location.href = checkoutUrl;
          })
          .catch(function () {
            checkoutBtn.disabled = false;
            checkoutBtn.classList.remove('loading');
            showError('Something went wrong adding this to your cart. Please try again.');
          });
      });
    }

    // Deep link from a product page: ?suit=<handle>
    var params = new URLSearchParams(window.location.search);
    var preselectHandle = params.get('suit');
    if (preselectHandle && suitPicker) {
      var match = suitPicker.cards.find(function (c) { return c.getAttribute('data-handle') === preselectHandle; });
      if (match) suitPicker.selectCard(match);
    }
  }

  document.querySelectorAll('[data-suit-builder]').forEach(init);
})();
